import * as React from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import { Translate } from 'react-localize-redux';
import RepairReleaseCtrl from '@webapp/controllers/release/repair-release';

interface RepairReleasePageProps {
  className?: string;
  releaseName?: string;
}

const mapStateToProps = (state: AppState) => ({
  releaseName: state.release.release?.title,
});

export const RepairReleasePage: React.FC<RepairReleasePageProps> = ({
  className,
  releaseName,
}) => {
  return (
    <RepairReleaseCtrl
      className={className}
      title={
        <>
          <Translate id="RELEASE.REPAIR.TITLE" /> {releaseName}
        </>
      }
    />
  );
};

export default connect(mapStateToProps)(RepairReleasePage);
